module.exports = __webpack_public_path__ + "assets/img/sungrow.138aeb2d.png";